
import { prefixLanguage } from '@utils/urls'
import { defineComponent } from 'vue'

export default defineComponent({
  // type inference enabled
  name: 'LanguageChanger',
  props: {
    // languages: {
    //   code: String,
    //   name: String,
    // },
    isDesktop: String,
  },
  data() {
    return {
      languages: window.languages_changer,
      language: ''
    }
  },
  mounted() {
    this.setDefaultLanguage()
  },
  methods: {
    changeLanguage(language) {
      // console.log('changeLanguage')
      const { code } = language
      // console.log('code', code)
      window.location.assign(
        prefixLanguage(
          // window.location.href, code
          window.location.pathname,
          { language: code }
        )
      )
    },
    setDefaultLanguage() {
      // console.log('setDefaultLanguage')
      this.languages.forEach(el => {
        if ('true' === el.is_current) {
          this.language = el
        }
      })
    },
    toggleSubMenu(event) {
      // console.log(event.currentTarget)
      const openMenus = Array.from(document.getElementsByClassName('is-open'))
      if (event.currentTarget.classList.contains('is-open')) {
        // если меню открыто, то закрываем его
        event.currentTarget.classList.remove("is-open")
      } else {
        // если меню закрыто, то закрываем все остальные меню
        openMenus.forEach(openMenu => {
          openMenu.classList.remove('is-open')
        })
        // открываем наше меню
        event.currentTarget.classList.add("is-open")
      }
      // openMenus.forEach(openMenu => {
      //   openMenu.classList.remove('is-open')
      // })
      // event.currentTarget.classList.toggle("is-open")
      // // document.getElementsByClassName("top-menu");
    },
    outside() {
      const openMenus = Array.from(document.getElementsByClassName('is-open'))
      openMenus.forEach(openMenu => {
        openMenu.classList.remove('is-open')
      })
    }
  },
})

